(function () {
  'use strict';

  function initialiseProductRow(row) {
    if (!row || row.dataset.aaReady === 'true') return;

    var track = row.querySelector('[data-aa-mega-track]');
    var items = track ? Array.prototype.slice.call(track.children) : [];
    var previous = row.querySelector('[data-aa-mega-prev]');
    var next = row.querySelector('[data-aa-mega-next]');
    var pageLabel = row.querySelector('[data-aa-mega-page]');
    var currentPage = 0;
    var perPage = 6;

    if (!track || !items.length) return;

    function totalPages() {
      return Math.max(1, Math.ceil(items.length / perPage));
    }

    function update() {
      var pages = totalPages();
      currentPage = Math.min(currentPage, pages - 1);
      var viewport = track.parentElement;
      track.style.transform = 'translate3d(' + (-currentPage * viewport.clientWidth) + 'px,0,0)';
      pageLabel.textContent = (currentPage + 1) + ' / ' + pages;
      previous.disabled = currentPage === 0;
      next.disabled = currentPage >= pages - 1;
    }

    previous.addEventListener('click', function () {
      if (currentPage > 0) currentPage -= 1;
      update();
    });

    next.addEventListener('click', function () {
      if (currentPage < totalPages() - 1) currentPage += 1;
      update();
    });

    window.addEventListener('resize', update);
    row.dataset.aaReady = 'true';
    update();
  }

  function initialise() {
    if (window.innerWidth >= 991) {
      document.querySelectorAll('[data-aa-mega-products]').forEach(initialiseProductRow);
    }

    document.querySelectorAll('[data-aa-desktop-open]').forEach(function (item) {
      if (window.innerWidth >= 991) {
        if (!item.open) {
          item.open = true;
          item.dataset.aaAutoOpened = 'true';
        }

        item.classList.remove('is-closing');
        item.classList.add('is-open');

        var panel = item.querySelector('.cc-accordion-item__panel');
        if (panel) panel.style.removeProperty('height');
      } else if (item.dataset.aaAutoOpened === 'true') {
        item.open = false;
        item.classList.remove('is-open', 'is-closing');

        var mobilePanel = item.querySelector('.cc-accordion-item__panel');
        if (mobilePanel) mobilePanel.style.removeProperty('height');

        delete item.dataset.aaAutoOpened;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', initialise);
  window.addEventListener('resize', initialise);
}());

(function () {
  'use strict';

  var mapIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s6-5.3 6-11a6 6 0 1 0-12 0c0 5.7 6 11 6 11Z"></path><circle cx="12" cy="10" r="2"></circle></svg>';
  var calendarIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"></rect><path d="M16 3v4M8 3v4M3 10h18"></path></svg>';

  function serviceLink(url, label, icon) {
    return '<a href="' + url + '" class="aa-header-service" aria-label="' + label + '">' + icon + '<span class="aa-header-service__label">' + label + '</span></a>';
  }

  function mobileServiceLink(url, label, icon) {
    return '<a href="' + url + '" aria-label="' + label + '">' + icon + '<span>' + label + '</span></a>';
  }

  function initialiseServiceLinks() {
    var utility = document.querySelector('.site-header .page-header .utils__right');
    if (utility && !utility.querySelector('.aa-header-services')) {
      var desktopLinks = document.createElement('div');
      desktopLinks.className = 'aa-header-services hide-for-search';
      desktopLinks.innerHTML = serviceLink('/pages/stores', 'Our Stores', mapIcon) + serviceLink('/pages/eye-test-booking', 'Free Eye Test', calendarIcon);
      var insertionPoint = utility.querySelector('.customer-account, .header-cart');
      utility.insertBefore(desktopLinks, insertionPoint);
    }

    var mobileNavigation = document.querySelector('.mobile-site-nav');
    if (mobileNavigation && !mobileNavigation.querySelector('.aa-mobile-service-links')) {
      var mobileLinks = document.createElement('li');
      mobileLinks.className = 'aa-mobile-service-links';
      mobileLinks.innerHTML = mobileServiceLink('/pages/stores', 'Our Stores', mapIcon) + mobileServiceLink('/pages/eye-test-booking', 'Free Eye Test', calendarIcon);
      mobileNavigation.appendChild(mobileLinks);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseServiceLinks);
  } else {
    initialiseServiceLinks();
  }

  document.addEventListener('shopify:section:load', initialiseServiceLinks);
}());
